import { COMPONENT_TYPE as TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View, { TimerType } from 'client/components/common/BuildingBlocks/Timer/Timer';

export const TIMER = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.TIMER,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: TIMER.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, TIMER.displayName),
				},
				componentProps: {
					[UNIFORM_PROPS.timerType]: TimerType.num,
					[UNIFORM_PROPS.timerTime]: 30,
					styles: {},
					other: {},
				},
			},
			children: [],
		},
	};
};

TIMER.displayName = 'Timer';
